//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IClient {
    /**
     * @return OK
     */
    getAllArticles(): Promise<ArticleDto[]>;

    /**
     * @return OK
     */
    getArticleById(id: number): Promise<ArticleDto>;

    /**
     * @return OK
     */
    getArticleByInnerCode(code: number): Promise<ArticleDto>;

    /**
     * @return OK
     */
    getArticleByOutterCode(code: number): Promise<ArticleDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateArticle(id: number, body: ArticleDto | undefined): Promise<ArticleDto>;

    /**
     * @return OK
     */
    deleteArticle(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewArticle(body: ArticleDto | undefined): Promise<ArticleDto>;

    /**
     * @param includeBatches (optional)
     * @return OK
     */
    getAllClients(includeBatches: boolean | undefined): Promise<ClientDto[]>;

    /**
     * @param includeBatches (optional)
     * @return OK
     */
    getClientById(id: number, includeBatches: boolean | undefined): Promise<ClientDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateClient(id: number, body: ClientDto | undefined): Promise<ClientDto>;

    /**
     * @return OK
     */
    deleteClient(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewClient(body: ClientDto | undefined): Promise<ClientDto>;

    /**
     * @return OK
     */
    getMyCompanyDetails(): Promise<CompanyDetailsDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewCompanyDetails(body: CompanyDetailsDto | undefined): Promise<CompanyDetailsDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateCompanyDetails(id: number, body: CompanyDetailsDto | undefined): Promise<CompanyDetailsDto>;

    /**
     * @return OK
     */
    deleteMyCompanyDetails(id: string): Promise<void>;

    /**
     * @return OK
     */
    getAllEmployees(): Promise<EmployeeDto[]>;

    /**
     * @return OK
     */
    getEmployee(id: number): Promise<EmployeeDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @return OK
     */
    deleteEmployee(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @return OK
     */
    getCommonInfo(): Promise<CommonInfoDto>;

    /**
     * @return OK
     */
    getAllGoods(): Promise<GoodsDto[]>;

    /**
     * @return OK
     */
    getAllGoodsForSite(siteId: number): Promise<GoodsDto[]>;

    /**
     * @return OK
     */
    getAllGoodsForOrder(orderId: number): Promise<GoodsDto[]>;

    /**
     * @return OK
     */
    getAllGoodsForPurchaseOrder(purchaseOrderId: number): Promise<GoodsDto[]>;

    /**
     * @return OK
     */
    getGoodsById(id: number): Promise<GoodsDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateGoods(id: number, body: GoodsDto | undefined): Promise<GoodsDto>;

    /**
     * @return OK
     */
    deleteGoods(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    reserveGoodsForOrder(body: OrderDto | undefined): Promise<GoodsDto[]>;

    /**
     * @param uniqueBatchId (optional)
     * @param batchArrivalDate (optional)
     * @param body (optional)
     * @return OK
     */
    transferGoodsForOrder(
        uniqueBatchId: string | undefined,
        batchArrivalDate: Date | undefined,
        body: OrderDto | undefined,
    ): Promise<GoodsDto[]>;

    /**
     * @param body (optional)
     * @return OK
     */
    returnGoodsToOriginForOrder(body: OrderDto | undefined): Promise<GoodsDto[]>;

    /**
     * @param body (optional)
     * @return OK
     */
    sellGoodsForSite(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]>;

    /**
     * @param body (optional)
     * @return OK
     */
    useGoodsForSite(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]>;

    /**
     * @param body (optional)
     * @return OK
     */
    writeOffGoodsForSite(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]>;

    /**
     * @param body (optional)
     * @return OK
     */
    writeOffGoodsForOrderInTransport(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]>;

    /**
     * @return OK
     */
    getBatchById(id: number): Promise<BatchDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateBatch(id: number, body: BatchDto | undefined): Promise<BatchDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewGoods(body: GoodsBatchItemDto | undefined): Promise<GoodsDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewGoodsForOrder(orderId: number, body: GoodsDto | undefined): Promise<GoodsDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrderGoodsItemForOrder(orderId: number, body: OrderGoodsItemDto | undefined): Promise<OrderGoodsItemDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrderGoodsItemForDemandOrder(
        orderId: number,
        body: OrderGoodsItemDto | undefined,
    ): Promise<OrderGoodsItemDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrderGoodsItemForReturnOrder(
        orderId: number,
        body: OrderGoodsItemDto | undefined,
    ): Promise<OrderGoodsItemDto>;

    /**
     * @return OK
     */
    getAllOrderGoodsItems(): Promise<OrderGoodsItemDto[]>;

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForOrder(orderId: number): Promise<OrderGoodsItemDto[]>;

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForOriginSite(siteId: number): Promise<OrderGoodsItemDto[]>;

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForDemandOrder(orderId: number): Promise<OrderGoodsItemDto[]>;

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForReturnOrder(orderId: number): Promise<OrderGoodsItemDto[]>;

    /**
     * @return OK
     */
    getAllApprovedOrderOrderGoodsItems(): Promise<OrderGoodsItemDto[]>;

    /**
     * @return OK
     */
    deleteOrderGoodsItem(orderGoodsItemId: number): Promise<void>;

    /**
     * @return OK
     */
    getAllLabels(): Promise<LabelDto[]>;

    /**
     * @return OK
     */
    getAllArticleLabels(): Promise<LabelDto[]>;

    /**
     * @return OK
     */
    getLabel(id: number): Promise<LabelDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateLabel(id: number, body: LabelDto | undefined): Promise<LabelDto>;

    /**
     * @return OK
     */
    deleteLabel(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewLabel(body: LabelDto | undefined): Promise<LabelDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewArticleLabel(articleId: number, body: LabelDto | undefined): Promise<LabelDto>;

    /**
     * @param articleId (optional)
     * @return OK
     */
    removeLabelFromArticle(labelId: number, articleId: number | undefined): Promise<void>;

    /**
     * @param includeSitesAndSupplier (optional)
     * @param includeWaybill (optional)
     * @param includeReceipts (optional)
     * @return OK
     */
    getAllOrders(
        includeSitesAndSupplier: boolean | undefined,
        includeWaybill: boolean | undefined,
        includeReceipts: boolean | undefined,
    ): Promise<OrderDataDto>;

    /**
     * @return OK
     */
    getAllDemandOrders(): Promise<DemandOrderDataDto>;

    /**
     * @return OK
     */
    getAllReturnOrders(): Promise<ReturnOrderDataDto>;

    /**
     * @return OK
     */
    getAllPurchaseOrders(): Promise<PurchaseOrderDataDto>;

    /**
     * @param includeSitesAndSupplier (optional)
     * @param includeWaybill (optional)
     * @param includeReceipts (optional)
     * @return OK
     */
    getOrder(
        id: number,
        includeSitesAndSupplier: boolean | undefined,
        includeWaybill: boolean | undefined,
        includeReceipts: boolean | undefined,
    ): Promise<OrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateOrder(id: number, body: OrderDto | undefined): Promise<OrderDto>;

    /**
     * @return OK
     */
    deleteOrder(id: number): Promise<void>;

    /**
     * @return OK
     */
    getDemandOrder(id: number): Promise<DemandOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateDemandOrder(id: number, body: DemandOrderDto | undefined): Promise<DemandOrderDto>;

    /**
     * @return OK
     */
    deleteDemandOrder(id: number): Promise<void>;

    /**
     * @return OK
     */
    getReturnOrder(id: number): Promise<ReturnOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateReturnOrder(id: number, body: ReturnOrderDto | undefined): Promise<ReturnOrderDto>;

    /**
     * @return OK
     */
    deleteReturnOrder(id: number): Promise<void>;

    /**
     * @return OK
     */
    getPurchaseOrder(id: number): Promise<PurchaseOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updatePurchaseOrder(id: number, body: PurchaseOrderDto | undefined): Promise<PurchaseOrderDto>;

    /**
     * @return OK
     */
    deletePurchaseOrder(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    changeOrderStatus(body: ChangeOrderStatusDto | undefined): Promise<OrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    changeDemandOrderStatus(body: ChangeDemandOrderStatusDto | undefined): Promise<DemandOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    changeReturnOrderStatus(body: ChangeReturnOrderStatusDto | undefined): Promise<ReturnOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    changePurchaseOrderStatus(body: ChangePurchaseOrderStatusDto | undefined): Promise<PurchaseOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrder(body: OrderDto | undefined): Promise<OrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewDemandOrder(body: DemandOrderDto | undefined): Promise<DemandOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewReturnOrder(body: ReturnOrderDto | undefined): Promise<ReturnOrderDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewPurchaseOrder(body: PurchaseOrderDto | undefined): Promise<PurchaseOrderDto>;

    /**
     * @param goodsId (optional)
     * @return OK
     */
    deleteGoodsOrderRelation(orderId: number, goodsId: number | undefined): Promise<void>;

    /**
     * @return OK
     */
    getOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto>;

    /**
     * @return OK
     */
    getDemandOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto>;

    /**
     * @return OK
     */
    getReturnOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto>;

    /**
     * @return OK
     */
    getPurchaseOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto>;

    /**
     * @param includeClient (optional)
     * @param includeSites (optional)
     * @param includeGoods (optional)
     * @return OK
     */
    getAllProjects(
        includeClient: boolean | undefined,
        includeSites: boolean | undefined,
        includeGoods: boolean | undefined,
    ): Promise<ProjectDto[]>;

    /**
     * @param includeClient (optional)
     * @param includeSites (optional)
     * @param includeGoods (optional)
     * @return OK
     */
    getAllProjectsForClient(
        clientId: number,
        includeClient: boolean | undefined,
        includeSites: boolean | undefined,
        includeGoods: boolean | undefined,
    ): Promise<ProjectDto[]>;

    /**
     * @param includeClient (optional)
     * @param includeSites (optional)
     * @param includeGoods (optional)
     * @return OK
     */
    getProjectById(
        id: number,
        includeClient: boolean | undefined,
        includeSites: boolean | undefined,
        includeGoods: boolean | undefined,
    ): Promise<ProjectDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateProject(id: number, body: ProjectDto | undefined): Promise<ProjectDto>;

    /**
     * @return OK
     */
    deleteProject(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewProject(body: ProjectDto | undefined): Promise<ProjectDto>;

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getAllReceipts(includeOrder: boolean | undefined): Promise<ReceiptDto[]>;

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getAllReceiptsForOrder(orderId: number, includeOrder: boolean | undefined): Promise<ReceiptDto[]>;

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getReceipt(id: number, includeOrder: boolean | undefined): Promise<ReceiptDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateReceipt(id: number, body: ReceiptDto | undefined): Promise<ReceiptDto>;

    /**
     * @return OK
     */
    deleteReceipt(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewReceipt(body: ReceiptDto | undefined): Promise<ReceiptDto>;

    /**
     * @param includeGoods (optional)
     * @param includeProject (optional)
     * @return OK
     */
    getAllSites(includeGoods: boolean | undefined, includeProject: boolean | undefined): Promise<SiteDto[]>;

    /**
     * @param includeGoods (optional)
     * @return OK
     */
    getAllSitesForProject(projectId: number, includeGoods: boolean | undefined): Promise<SiteDto[]>;

    /**
     * @param includeGoods (optional)
     * @return OK
     */
    getAllSitesForClient(clientId: number, includeGoods: boolean | undefined): Promise<SiteDto[]>;

    /**
     * @param includeGoods (optional)
     * @param includeProject (optional)
     * @return OK
     */
    getSiteById(id: number, includeGoods: boolean | undefined, includeProject: boolean | undefined): Promise<SiteDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateSite(id: number, body: SiteDto | undefined): Promise<SiteDto>;

    /**
     * @return OK
     */
    deleteSite(id: number): Promise<void>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewSite(projectId: number, body: SiteDto | undefined): Promise<SiteDto>;

    /**
     * @return OK
     */
    getAllSituationsForSite(siteId: number): Promise<SituationDto[]>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewSituationForSite(siteId: number, body: SituationDto | undefined): Promise<SituationDto>;

    /**
     * @return OK
     */
    getSituationById(id: number): Promise<SituationDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateSituation(id: number, body: SituationDto | undefined): Promise<SituationDto>;

    /**
     * @return OK
     */
    deleteSituation(id: number): Promise<void>;

    /**
     * @return OK
     */
    getHelloWorld(): Promise<string>;

    /**
     * @param name (optional)
     * @return OK
     */
    getHelloYou(name: string | undefined): Promise<string>;

    /**
     * @return OK
     */
    getHelloSuperAdmin(): Promise<string>;

    /**
     * @return OK
     */
    getHelloSystemAdmin(): Promise<string>;

    /**
     * @return OK
     */
    getHelloEmployee(): Promise<string>;

    /**
     * @return OK
     */
    getHelloCEO(): Promise<string>;

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getAllWaybills(includeOrder: boolean | undefined): Promise<WaybillDto[]>;

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getWaybill(id: number, includeOrder: boolean | undefined): Promise<WaybillDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    updateWaybill(id: number, body: WaybillDto | undefined): Promise<WaybillDto>;

    /**
     * @return OK
     */
    deleteWaybill(id: number): Promise<void>;

    /**
     * @return OK
     */
    getFullWaybillInfo(id: number): Promise<WaybillFullInfoDto>;

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getWaybillForOrder(orderId: number, includeOrder: boolean | undefined): Promise<WaybillDto>;

    /**
     * @param body (optional)
     * @return OK
     */
    addNewWaybill(body: WaybillDto | undefined): Promise<WaybillDto>;
}

export class Client implements IClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : (window as any);
        this.baseUrl = baseUrl ?? '';
    }

    /**
     * @return OK
     */
    getAllArticles(): Promise<ArticleDto[]> {
        let url_ = this.baseUrl + '/api/Article/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllArticles(_response);
        });
    }

    protected processGetAllArticles(response: Response): Promise<ArticleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ArticleDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getArticleById(id: number): Promise<ArticleDto> {
        let url_ = this.baseUrl + '/api/Article/byId/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleById(_response);
        });
    }

    protected processGetArticleById(response: Response): Promise<ArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ArticleDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    /**
     * @return OK
     */
    getArticleByInnerCode(code: number): Promise<ArticleDto> {
        let url_ = this.baseUrl + '/api/Article/byInnerCode/{code}';
        if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace('{code}', encodeURIComponent('' + code));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleByInnerCode(_response);
        });
    }

    protected processGetArticleByInnerCode(response: Response): Promise<ArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ArticleDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    /**
     * @return OK
     */
    getArticleByOutterCode(code: number): Promise<ArticleDto> {
        let url_ = this.baseUrl + '/api/Article/byOutterCode/{code}';
        if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace('{code}', encodeURIComponent('' + code));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleByOutterCode(_response);
        });
    }

    protected processGetArticleByOutterCode(response: Response): Promise<ArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ArticleDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateArticle(id: number, body: ArticleDto | undefined): Promise<ArticleDto> {
        let url_ = this.baseUrl + '/api/Article/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArticle(_response);
        });
    }

    protected processUpdateArticle(response: Response): Promise<ArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ArticleDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteArticle(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Article/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewArticle(body: ArticleDto | undefined): Promise<ArticleDto> {
        let url_ = this.baseUrl + '/api/Article';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewArticle(_response);
        });
    }

    protected processAddNewArticle(response: Response): Promise<ArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ArticleDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeBatches (optional)
     * @return OK
     */
    getAllClients(includeBatches: boolean | undefined): Promise<ClientDto[]> {
        let url_ = this.baseUrl + '/api/Client/all?';
        if (includeBatches === null) throw new Error("The parameter 'includeBatches' cannot be null.");
        else if (includeBatches !== undefined)
            url_ += 'includeBatches=' + encodeURIComponent('' + includeBatches) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllClients(_response);
        });
    }

    protected processGetAllClients(response: Response): Promise<ClientDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ClientDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto[]>(null as any);
    }

    /**
     * @param includeBatches (optional)
     * @return OK
     */
    getClientById(id: number, includeBatches: boolean | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + '/api/Client/byId/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (includeBatches === null) throw new Error("The parameter 'includeBatches' cannot be null.");
        else if (includeBatches !== undefined)
            url_ += 'includeBatches=' + encodeURIComponent('' + includeBatches) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientById(_response);
        });
    }

    protected processGetClientById(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateClient(id: number, body: ClientDto | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + '/api/Client/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateClient(_response);
        });
    }

    protected processUpdateClient(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteClient(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Client/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteClient(_response);
        });
    }

    protected processDeleteClient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewClient(body: ClientDto | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + '/api/Client';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewClient(_response);
        });
    }

    protected processAddNewClient(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getMyCompanyDetails(): Promise<CompanyDetailsDto> {
        let url_ = this.baseUrl + '/api/CompanyDetails';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCompanyDetails(_response);
        });
    }

    protected processGetMyCompanyDetails(response: Response): Promise<CompanyDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyDetailsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDetailsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewCompanyDetails(body: CompanyDetailsDto | undefined): Promise<CompanyDetailsDto> {
        let url_ = this.baseUrl + '/api/CompanyDetails';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewCompanyDetails(_response);
        });
    }

    protected processAddNewCompanyDetails(response: Response): Promise<CompanyDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyDetailsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateCompanyDetails(id: number, body: CompanyDetailsDto | undefined): Promise<CompanyDetailsDto> {
        let url_ = this.baseUrl + '/api/CompanyDetails/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCompanyDetails(_response);
        });
    }

    protected processUpdateCompanyDetails(response: Response): Promise<CompanyDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyDetailsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteMyCompanyDetails(id: string): Promise<void> {
        let url_ = this.baseUrl + '/api/CompanyDetails/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMyCompanyDetails(_response);
        });
    }

    protected processDeleteMyCompanyDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAllEmployees(): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + '/api/Employee/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployees(_response);
        });
    }

    protected processGetAllEmployees(response: Response): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(EmployeeDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getEmployee(id: number): Promise<EmployeeDto> {
        let url_ = this.baseUrl + '/api/Employee/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeeDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + '/api/Employee/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeeDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteEmployee(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Employee/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmployee(_response);
        });
    }

    protected processDeleteEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + '/api/Employee';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployee(_response);
        });
    }

    protected processAddNewEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeeDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getCommonInfo(): Promise<CommonInfoDto> {
        let url_ = this.baseUrl + '/api/Employee/commonInfo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommonInfo(_response);
        });
    }

    protected processGetCommonInfo(response: Response): Promise<CommonInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CommonInfoDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommonInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    getAllGoods(): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllGoods(_response);
        });
    }

    protected processGetAllGoods(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllGoodsForSite(siteId: number): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/forSite/{siteId}';
        if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace('{siteId}', encodeURIComponent('' + siteId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllGoodsForSite(_response);
        });
    }

    protected processGetAllGoodsForSite(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllGoodsForOrder(orderId: number): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/forOrder/{orderId}';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllGoodsForOrder(_response);
        });
    }

    protected processGetAllGoodsForOrder(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllGoodsForPurchaseOrder(purchaseOrderId: number): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/forPurchaseOrder/{purchaseOrderId}';
        if (purchaseOrderId === undefined || purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' must be defined.");
        url_ = url_.replace('{purchaseOrderId}', encodeURIComponent('' + purchaseOrderId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllGoodsForPurchaseOrder(_response);
        });
    }

    protected processGetAllGoodsForPurchaseOrder(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getGoodsById(id: number): Promise<GoodsDto> {
        let url_ = this.baseUrl + '/api/Goods/byId/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGoodsById(_response);
        });
    }

    protected processGetGoodsById(response: Response): Promise<GoodsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateGoods(id: number, body: GoodsDto | undefined): Promise<GoodsDto> {
        let url_ = this.baseUrl + '/api/Goods/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGoods(_response);
        });
    }

    protected processUpdateGoods(response: Response): Promise<GoodsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteGoods(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Goods/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteGoods(_response);
        });
    }

    protected processDeleteGoods(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    reserveGoodsForOrder(body: OrderDto | undefined): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/reserve';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReserveGoodsForOrder(_response);
        });
    }

    protected processReserveGoodsForOrder(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param uniqueBatchId (optional)
     * @param batchArrivalDate (optional)
     * @param body (optional)
     * @return OK
     */
    transferGoodsForOrder(
        uniqueBatchId: string | undefined,
        batchArrivalDate: Date | undefined,
        body: OrderDto | undefined,
    ): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/transfer?';
        if (uniqueBatchId === null) throw new Error("The parameter 'uniqueBatchId' cannot be null.");
        else if (uniqueBatchId !== undefined) url_ += 'uniqueBatchId=' + encodeURIComponent('' + uniqueBatchId) + '&';
        if (batchArrivalDate === null) throw new Error("The parameter 'batchArrivalDate' cannot be null.");
        else if (batchArrivalDate !== undefined)
            url_ +=
                'batchArrivalDate=' +
                encodeURIComponent(batchArrivalDate ? '' + batchArrivalDate.toISOString() : '') +
                '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferGoodsForOrder(_response);
        });
    }

    protected processTransferGoodsForOrder(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    returnGoodsToOriginForOrder(body: OrderDto | undefined): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/return';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReturnGoodsToOriginForOrder(_response);
        });
    }

    protected processReturnGoodsToOriginForOrder(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    sellGoodsForSite(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/sell';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSellGoodsForSite(_response);
        });
    }

    protected processSellGoodsForSite(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    useGoodsForSite(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/use';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUseGoodsForSite(_response);
        });
    }

    protected processUseGoodsForSite(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    writeOffGoodsForSite(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/writeOff';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWriteOffGoodsForSite(_response);
        });
    }

    protected processWriteOffGoodsForSite(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    writeOffGoodsForOrderInTransport(body: GoodsManipulationItemDto | undefined): Promise<GoodsDto[]> {
        let url_ = this.baseUrl + '/api/Goods/writeOffInTransport';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWriteOffGoodsForOrderInTransport(_response);
        });
    }

    protected processWriteOffGoodsForOrderInTransport(response: Response): Promise<GoodsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(GoodsDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getBatchById(id: number): Promise<BatchDto> {
        let url_ = this.baseUrl + '/api/Goods/batch/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchById(_response);
        });
    }

    protected processGetBatchById(response: Response): Promise<BatchDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BatchDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateBatch(id: number, body: BatchDto | undefined): Promise<BatchDto> {
        let url_ = this.baseUrl + '/api/Goods/batch/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBatch(_response);
        });
    }

    protected processUpdateBatch(response: Response): Promise<BatchDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BatchDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewGoods(body: GoodsBatchItemDto | undefined): Promise<GoodsDto> {
        let url_ = this.baseUrl + '/api/Goods';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewGoods(_response);
        });
    }

    protected processAddNewGoods(response: Response): Promise<GoodsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewGoodsForOrder(orderId: number, body: GoodsDto | undefined): Promise<GoodsDto> {
        let url_ = this.baseUrl + '/api/Goods/order/{orderId}';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewGoodsForOrder(_response);
        });
    }

    protected processAddNewGoodsForOrder(response: Response): Promise<GoodsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrderGoodsItemForOrder(orderId: number, body: OrderGoodsItemDto | undefined): Promise<OrderGoodsItemDto> {
        let url_ = this.baseUrl + '/api/Goods/order/{orderId}/orderGoodsItem';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewOrderGoodsItemForOrder(_response);
        });
    }

    protected processAddNewOrderGoodsItemForOrder(response: Response): Promise<OrderGoodsItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderGoodsItemDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrderGoodsItemForDemandOrder(
        orderId: number,
        body: OrderGoodsItemDto | undefined,
    ): Promise<OrderGoodsItemDto> {
        let url_ = this.baseUrl + '/api/Goods/demandOrder/{orderId}/orderGoodsItem';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewOrderGoodsItemForDemandOrder(_response);
        });
    }

    protected processAddNewOrderGoodsItemForDemandOrder(response: Response): Promise<OrderGoodsItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderGoodsItemDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrderGoodsItemForReturnOrder(
        orderId: number,
        body: OrderGoodsItemDto | undefined,
    ): Promise<OrderGoodsItemDto> {
        let url_ = this.baseUrl + '/api/Goods/returnOrder/{orderId}/orderGoodsItem';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewOrderGoodsItemForReturnOrder(_response);
        });
    }

    protected processAddNewOrderGoodsItemForReturnOrder(response: Response): Promise<OrderGoodsItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderGoodsItemDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllOrderGoodsItems(): Promise<OrderGoodsItemDto[]> {
        let url_ = this.baseUrl + '/api/Goods/allOrderGoodsItems';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrderGoodsItems(_response);
        });
    }

    protected processGetAllOrderGoodsItems(response: Response): Promise<OrderGoodsItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderGoodsItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForOrder(orderId: number): Promise<OrderGoodsItemDto[]> {
        let url_ = this.baseUrl + '/api/Goods/order/{orderId}/allOrderGoodsItems';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrderGoodsItemsForOrder(_response);
        });
    }

    protected processGetAllOrderGoodsItemsForOrder(response: Response): Promise<OrderGoodsItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderGoodsItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForOriginSite(siteId: number): Promise<OrderGoodsItemDto[]> {
        let url_ = this.baseUrl + '/api/Goods/originSite/{siteId}/allOrderGoodsItems';
        if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace('{siteId}', encodeURIComponent('' + siteId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrderGoodsItemsForOriginSite(_response);
        });
    }

    protected processGetAllOrderGoodsItemsForOriginSite(response: Response): Promise<OrderGoodsItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderGoodsItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForDemandOrder(orderId: number): Promise<OrderGoodsItemDto[]> {
        let url_ = this.baseUrl + '/api/Goods/demandOrder/{orderId}/allOrderGoodsItems';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrderGoodsItemsForDemandOrder(_response);
        });
    }

    protected processGetAllOrderGoodsItemsForDemandOrder(response: Response): Promise<OrderGoodsItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderGoodsItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllOrderGoodsItemsForReturnOrder(orderId: number): Promise<OrderGoodsItemDto[]> {
        let url_ = this.baseUrl + '/api/Goods/returnOrder/{orderId}/allOrderGoodsItems';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrderGoodsItemsForReturnOrder(_response);
        });
    }

    protected processGetAllOrderGoodsItemsForReturnOrder(response: Response): Promise<OrderGoodsItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderGoodsItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllApprovedOrderOrderGoodsItems(): Promise<OrderGoodsItemDto[]> {
        let url_ = this.baseUrl + '/api/Goods/allApprovedOrderOrderGoodsItems';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllApprovedOrderOrderGoodsItems(_response);
        });
    }

    protected processGetAllApprovedOrderOrderGoodsItems(response: Response): Promise<OrderGoodsItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderGoodsItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteOrderGoodsItem(orderGoodsItemId: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Goods/orderGoodsItem/{orderGoodsItemId}';
        if (orderGoodsItemId === undefined || orderGoodsItemId === null)
            throw new Error("The parameter 'orderGoodsItemId' must be defined.");
        url_ = url_.replace('{orderGoodsItemId}', encodeURIComponent('' + orderGoodsItemId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOrderGoodsItem(_response);
        });
    }

    protected processDeleteOrderGoodsItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllLabels(): Promise<LabelDto[]> {
        let url_ = this.baseUrl + '/api/Label/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllLabels(_response);
        });
    }

    protected processGetAllLabels(response: Response): Promise<LabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(LabelDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllArticleLabels(): Promise<LabelDto[]> {
        let url_ = this.baseUrl + '/api/Label/all/forArticles';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllArticleLabels(_response);
        });
    }

    protected processGetAllArticleLabels(response: Response): Promise<LabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(LabelDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getLabel(id: number): Promise<LabelDto> {
        let url_ = this.baseUrl + '/api/Label/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLabel(_response);
        });
    }

    protected processGetLabel(response: Response): Promise<LabelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LabelDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateLabel(id: number, body: LabelDto | undefined): Promise<LabelDto> {
        let url_ = this.baseUrl + '/api/Label/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLabel(_response);
        });
    }

    protected processUpdateLabel(response: Response): Promise<LabelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LabelDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteLabel(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Label/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLabel(_response);
        });
    }

    protected processDeleteLabel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewLabel(body: LabelDto | undefined): Promise<LabelDto> {
        let url_ = this.baseUrl + '/api/Label';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewLabel(_response);
        });
    }

    protected processAddNewLabel(response: Response): Promise<LabelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LabelDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewArticleLabel(articleId: number, body: LabelDto | undefined): Promise<LabelDto> {
        let url_ = this.baseUrl + '/api/Label/forArticle/{articleId}';
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace('{articleId}', encodeURIComponent('' + articleId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewArticleLabel(_response);
        });
    }

    protected processAddNewArticleLabel(response: Response): Promise<LabelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LabelDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param articleId (optional)
     * @return OK
     */
    removeLabelFromArticle(labelId: number, articleId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/Label/{labelId}/removeFromArticle?';
        if (labelId === undefined || labelId === null) throw new Error("The parameter 'labelId' must be defined.");
        url_ = url_.replace('{labelId}', encodeURIComponent('' + labelId));
        if (articleId === null) throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined) url_ += 'articleId=' + encodeURIComponent('' + articleId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'POST',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveLabelFromArticle(_response);
        });
    }

    protected processRemoveLabelFromArticle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeSitesAndSupplier (optional)
     * @param includeWaybill (optional)
     * @param includeReceipts (optional)
     * @return OK
     */
    getAllOrders(
        includeSitesAndSupplier: boolean | undefined,
        includeWaybill: boolean | undefined,
        includeReceipts: boolean | undefined,
    ): Promise<OrderDataDto> {
        let url_ = this.baseUrl + '/api/Order/all?';
        if (includeSitesAndSupplier === null)
            throw new Error("The parameter 'includeSitesAndSupplier' cannot be null.");
        else if (includeSitesAndSupplier !== undefined)
            url_ += 'includeSitesAndSupplier=' + encodeURIComponent('' + includeSitesAndSupplier) + '&';
        if (includeWaybill === null) throw new Error("The parameter 'includeWaybill' cannot be null.");
        else if (includeWaybill !== undefined)
            url_ += 'includeWaybill=' + encodeURIComponent('' + includeWaybill) + '&';
        if (includeReceipts === null) throw new Error("The parameter 'includeReceipts' cannot be null.");
        else if (includeReceipts !== undefined)
            url_ += 'includeReceipts=' + encodeURIComponent('' + includeReceipts) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOrders(_response);
        });
    }

    protected processGetAllOrders(response: Response): Promise<OrderDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderDataDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDataDto>(null as any);
    }

    /**
     * @return OK
     */
    getAllDemandOrders(): Promise<DemandOrderDataDto> {
        let url_ = this.baseUrl + '/api/Order/demandOrders/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDemandOrders(_response);
        });
    }

    protected processGetAllDemandOrders(response: Response): Promise<DemandOrderDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DemandOrderDataDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<DemandOrderDataDto>(null as any);
    }

    /**
     * @return OK
     */
    getAllReturnOrders(): Promise<ReturnOrderDataDto> {
        let url_ = this.baseUrl + '/api/Order/returnOrders/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllReturnOrders(_response);
        });
    }

    protected processGetAllReturnOrders(response: Response): Promise<ReturnOrderDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnOrderDataDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReturnOrderDataDto>(null as any);
    }

    /**
     * @return OK
     */
    getAllPurchaseOrders(): Promise<PurchaseOrderDataDto> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrders/all';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPurchaseOrders(_response);
        });
    }

    protected processGetAllPurchaseOrders(response: Response): Promise<PurchaseOrderDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderDataDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderDataDto>(null as any);
    }

    /**
     * @param includeSitesAndSupplier (optional)
     * @param includeWaybill (optional)
     * @param includeReceipts (optional)
     * @return OK
     */
    getOrder(
        id: number,
        includeSitesAndSupplier: boolean | undefined,
        includeWaybill: boolean | undefined,
        includeReceipts: boolean | undefined,
    ): Promise<OrderDto> {
        let url_ = this.baseUrl + '/api/Order/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (includeSitesAndSupplier === null)
            throw new Error("The parameter 'includeSitesAndSupplier' cannot be null.");
        else if (includeSitesAndSupplier !== undefined)
            url_ += 'includeSitesAndSupplier=' + encodeURIComponent('' + includeSitesAndSupplier) + '&';
        if (includeWaybill === null) throw new Error("The parameter 'includeWaybill' cannot be null.");
        else if (includeWaybill !== undefined)
            url_ += 'includeWaybill=' + encodeURIComponent('' + includeWaybill) + '&';
        if (includeReceipts === null) throw new Error("The parameter 'includeReceipts' cannot be null.");
        else if (includeReceipts !== undefined)
            url_ += 'includeReceipts=' + encodeURIComponent('' + includeReceipts) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrder(_response);
        });
    }

    protected processGetOrder(response: Response): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateOrder(id: number, body: OrderDto | undefined): Promise<OrderDto> {
        let url_ = this.baseUrl + '/api/Order/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOrder(_response);
        });
    }

    protected processUpdateOrder(response: Response): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteOrder(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Order/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOrder(_response);
        });
    }

    protected processDeleteOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getDemandOrder(id: number): Promise<DemandOrderDto> {
        let url_ = this.baseUrl + '/api/Order/demandOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDemandOrder(_response);
        });
    }

    protected processGetDemandOrder(response: Response): Promise<DemandOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DemandOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<DemandOrderDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateDemandOrder(id: number, body: DemandOrderDto | undefined): Promise<DemandOrderDto> {
        let url_ = this.baseUrl + '/api/Order/demandOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDemandOrder(_response);
        });
    }

    protected processUpdateDemandOrder(response: Response): Promise<DemandOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DemandOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteDemandOrder(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Order/demandOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDemandOrder(_response);
        });
    }

    protected processDeleteDemandOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getReturnOrder(id: number): Promise<ReturnOrderDto> {
        let url_ = this.baseUrl + '/api/Order/returnOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReturnOrder(_response);
        });
    }

    protected processGetReturnOrder(response: Response): Promise<ReturnOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReturnOrderDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateReturnOrder(id: number, body: ReturnOrderDto | undefined): Promise<ReturnOrderDto> {
        let url_ = this.baseUrl + '/api/Order/returnOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateReturnOrder(_response);
        });
    }

    protected processUpdateReturnOrder(response: Response): Promise<ReturnOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteReturnOrder(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Order/returnOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteReturnOrder(_response);
        });
    }

    protected processDeleteReturnOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getPurchaseOrder(id: number): Promise<PurchaseOrderDto> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPurchaseOrder(_response);
        });
    }

    protected processGetPurchaseOrder(response: Response): Promise<PurchaseOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updatePurchaseOrder(id: number, body: PurchaseOrderDto | undefined): Promise<PurchaseOrderDto> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePurchaseOrder(_response);
        });
    }

    protected processUpdatePurchaseOrder(response: Response): Promise<PurchaseOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deletePurchaseOrder(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePurchaseOrder(_response);
        });
    }

    protected processDeletePurchaseOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    changeOrderStatus(body: ChangeOrderStatusDto | undefined): Promise<OrderDto> {
        let url_ = this.baseUrl + '/api/Order/orderStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeOrderStatus(_response);
        });
    }

    protected processChangeOrderStatus(response: Response): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    changeDemandOrderStatus(body: ChangeDemandOrderStatusDto | undefined): Promise<DemandOrderDto> {
        let url_ = this.baseUrl + '/api/Order/demandOrderStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeDemandOrderStatus(_response);
        });
    }

    protected processChangeDemandOrderStatus(response: Response): Promise<DemandOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DemandOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    changeReturnOrderStatus(body: ChangeReturnOrderStatusDto | undefined): Promise<ReturnOrderDto> {
        let url_ = this.baseUrl + '/api/Order/returnOrderStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeReturnOrderStatus(_response);
        });
    }

    protected processChangeReturnOrderStatus(response: Response): Promise<ReturnOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    changePurchaseOrderStatus(body: ChangePurchaseOrderStatusDto | undefined): Promise<PurchaseOrderDto> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrderStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePurchaseOrderStatus(_response);
        });
    }

    protected processChangePurchaseOrderStatus(response: Response): Promise<PurchaseOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewOrder(body: OrderDto | undefined): Promise<OrderDto> {
        let url_ = this.baseUrl + '/api/Order';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewOrder(_response);
        });
    }

    protected processAddNewOrder(response: Response): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewDemandOrder(body: DemandOrderDto | undefined): Promise<DemandOrderDto> {
        let url_ = this.baseUrl + '/api/Order/demandOrders';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewDemandOrder(_response);
        });
    }

    protected processAddNewDemandOrder(response: Response): Promise<DemandOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DemandOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewReturnOrder(body: ReturnOrderDto | undefined): Promise<ReturnOrderDto> {
        let url_ = this.baseUrl + '/api/Order/returnOrders';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewReturnOrder(_response);
        });
    }

    protected processAddNewReturnOrder(response: Response): Promise<ReturnOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewPurchaseOrder(body: PurchaseOrderDto | undefined): Promise<PurchaseOrderDto> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrders';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewPurchaseOrder(_response);
        });
    }

    protected processAddNewPurchaseOrder(response: Response): Promise<PurchaseOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param goodsId (optional)
     * @return OK
     */
    deleteGoodsOrderRelation(orderId: number, goodsId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/Order/goodsOrderRelation/{orderId}?';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        if (goodsId === null) throw new Error("The parameter 'goodsId' cannot be null.");
        else if (goodsId !== undefined) url_ += 'goodsId=' + encodeURIComponent('' + goodsId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteGoodsOrderRelation(_response);
        });
    }

    protected processDeleteGoodsOrderRelation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto> {
        let url_ = this.baseUrl + '/api/Order/refreshInfo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrdersDataRefreshInfo(_response);
        });
    }

    protected processGetOrdersDataRefreshInfo(response: Response): Promise<GetOrdersDataRefreshInfoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOrdersDataRefreshInfoResponseDto.fromJS(resultData200);
                return result200;
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getDemandOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto> {
        let url_ = this.baseUrl + '/api/Order/demandOrders/refreshInfo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDemandOrdersDataRefreshInfo(_response);
        });
    }

    protected processGetDemandOrdersDataRefreshInfo(response: Response): Promise<GetOrdersDataRefreshInfoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOrdersDataRefreshInfoResponseDto.fromJS(resultData200);
                return result200;
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getReturnOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto> {
        let url_ = this.baseUrl + '/api/Order/returnOrders/refreshInfo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReturnOrdersDataRefreshInfo(_response);
        });
    }

    protected processGetReturnOrdersDataRefreshInfo(response: Response): Promise<GetOrdersDataRefreshInfoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOrdersDataRefreshInfoResponseDto.fromJS(resultData200);
                return result200;
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getPurchaseOrdersDataRefreshInfo(): Promise<GetOrdersDataRefreshInfoResponseDto> {
        let url_ = this.baseUrl + '/api/Order/purchaseOrders/refreshInfo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPurchaseOrdersDataRefreshInfo(_response);
        });
    }

    protected processGetPurchaseOrdersDataRefreshInfo(
        response: Response,
    ): Promise<GetOrdersDataRefreshInfoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOrdersDataRefreshInfoResponseDto.fromJS(resultData200);
                return result200;
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeClient (optional)
     * @param includeSites (optional)
     * @param includeGoods (optional)
     * @return OK
     */
    getAllProjects(
        includeClient: boolean | undefined,
        includeSites: boolean | undefined,
        includeGoods: boolean | undefined,
    ): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + '/api/Project/all?';
        if (includeClient === null) throw new Error("The parameter 'includeClient' cannot be null.");
        else if (includeClient !== undefined) url_ += 'includeClient=' + encodeURIComponent('' + includeClient) + '&';
        if (includeSites === null) throw new Error("The parameter 'includeSites' cannot be null.");
        else if (includeSites !== undefined) url_ += 'includeSites=' + encodeURIComponent('' + includeSites) + '&';
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProjects(_response);
        });
    }

    protected processGetAllProjects(response: Response): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ProjectDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    /**
     * @param includeClient (optional)
     * @param includeSites (optional)
     * @param includeGoods (optional)
     * @return OK
     */
    getAllProjectsForClient(
        clientId: number,
        includeClient: boolean | undefined,
        includeSites: boolean | undefined,
        includeGoods: boolean | undefined,
    ): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + '/api/Project/forClient/{clientId}?';
        if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
        if (includeClient === null) throw new Error("The parameter 'includeClient' cannot be null.");
        else if (includeClient !== undefined) url_ += 'includeClient=' + encodeURIComponent('' + includeClient) + '&';
        if (includeSites === null) throw new Error("The parameter 'includeSites' cannot be null.");
        else if (includeSites !== undefined) url_ += 'includeSites=' + encodeURIComponent('' + includeSites) + '&';
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProjectsForClient(_response);
        });
    }

    protected processGetAllProjectsForClient(response: Response): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ProjectDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    /**
     * @param includeClient (optional)
     * @param includeSites (optional)
     * @param includeGoods (optional)
     * @return OK
     */
    getProjectById(
        id: number,
        includeClient: boolean | undefined,
        includeSites: boolean | undefined,
        includeGoods: boolean | undefined,
    ): Promise<ProjectDto> {
        let url_ = this.baseUrl + '/api/Project/byId/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (includeClient === null) throw new Error("The parameter 'includeClient' cannot be null.");
        else if (includeClient !== undefined) url_ += 'includeClient=' + encodeURIComponent('' + includeClient) + '&';
        if (includeSites === null) throw new Error("The parameter 'includeSites' cannot be null.");
        else if (includeSites !== undefined) url_ += 'includeSites=' + encodeURIComponent('' + includeSites) + '&';
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectById(_response);
        });
    }

    protected processGetProjectById(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateProject(id: number, body: ProjectDto | undefined): Promise<ProjectDto> {
        let url_ = this.baseUrl + '/api/Project/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProject(_response);
        });
    }

    protected processUpdateProject(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteProject(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Project/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewProject(body: ProjectDto | undefined): Promise<ProjectDto> {
        let url_ = this.baseUrl + '/api/Project';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewProject(_response);
        });
    }

    protected processAddNewProject(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getAllReceipts(includeOrder: boolean | undefined): Promise<ReceiptDto[]> {
        let url_ = this.baseUrl + '/api/Receipt/all?';
        if (includeOrder === null) throw new Error("The parameter 'includeOrder' cannot be null.");
        else if (includeOrder !== undefined) url_ += 'includeOrder=' + encodeURIComponent('' + includeOrder) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllReceipts(_response);
        });
    }

    protected processGetAllReceipts(response: Response): Promise<ReceiptDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ReceiptDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto[]>(null as any);
    }

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getAllReceiptsForOrder(orderId: number, includeOrder: boolean | undefined): Promise<ReceiptDto[]> {
        let url_ = this.baseUrl + '/api/Receipt/forOrder/{orderId}?';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        if (includeOrder === null) throw new Error("The parameter 'includeOrder' cannot be null.");
        else if (includeOrder !== undefined) url_ += 'includeOrder=' + encodeURIComponent('' + includeOrder) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllReceiptsForOrder(_response);
        });
    }

    protected processGetAllReceiptsForOrder(response: Response): Promise<ReceiptDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ReceiptDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto[]>(null as any);
    }

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getReceipt(id: number, includeOrder: boolean | undefined): Promise<ReceiptDto> {
        let url_ = this.baseUrl + '/api/Receipt/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (includeOrder === null) throw new Error("The parameter 'includeOrder' cannot be null.");
        else if (includeOrder !== undefined) url_ += 'includeOrder=' + encodeURIComponent('' + includeOrder) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceipt(_response);
        });
    }

    protected processGetReceipt(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReceiptDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateReceipt(id: number, body: ReceiptDto | undefined): Promise<ReceiptDto> {
        let url_ = this.baseUrl + '/api/Receipt/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateReceipt(_response);
        });
    }

    protected processUpdateReceipt(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReceiptDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteReceipt(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Receipt/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteReceipt(_response);
        });
    }

    protected processDeleteReceipt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewReceipt(body: ReceiptDto | undefined): Promise<ReceiptDto> {
        let url_ = this.baseUrl + '/api/Receipt';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewReceipt(_response);
        });
    }

    protected processAddNewReceipt(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReceiptDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeGoods (optional)
     * @param includeProject (optional)
     * @return OK
     */
    getAllSites(includeGoods: boolean | undefined, includeProject: boolean | undefined): Promise<SiteDto[]> {
        let url_ = this.baseUrl + '/api/Site/all?';
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        if (includeProject === null) throw new Error("The parameter 'includeProject' cannot be null.");
        else if (includeProject !== undefined)
            url_ += 'includeProject=' + encodeURIComponent('' + includeProject) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSites(_response);
        });
    }

    protected processGetAllSites(response: Response): Promise<SiteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(SiteDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteDto[]>(null as any);
    }

    /**
     * @param includeGoods (optional)
     * @return OK
     */
    getAllSitesForProject(projectId: number, includeGoods: boolean | undefined): Promise<SiteDto[]> {
        let url_ = this.baseUrl + '/api/Site/forProject/{projectId}?';
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSitesForProject(_response);
        });
    }

    protected processGetAllSitesForProject(response: Response): Promise<SiteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(SiteDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteDto[]>(null as any);
    }

    /**
     * @param includeGoods (optional)
     * @return OK
     */
    getAllSitesForClient(clientId: number, includeGoods: boolean | undefined): Promise<SiteDto[]> {
        let url_ = this.baseUrl + '/api/Site/forClient/{clientId}?';
        if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSitesForClient(_response);
        });
    }

    protected processGetAllSitesForClient(response: Response): Promise<SiteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(SiteDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteDto[]>(null as any);
    }

    /**
     * @param includeGoods (optional)
     * @param includeProject (optional)
     * @return OK
     */
    getSiteById(id: number, includeGoods: boolean | undefined, includeProject: boolean | undefined): Promise<SiteDto> {
        let url_ = this.baseUrl + '/api/Site/byId/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (includeGoods === null) throw new Error("The parameter 'includeGoods' cannot be null.");
        else if (includeGoods !== undefined) url_ += 'includeGoods=' + encodeURIComponent('' + includeGoods) + '&';
        if (includeProject === null) throw new Error("The parameter 'includeProject' cannot be null.");
        else if (includeProject !== undefined)
            url_ += 'includeProject=' + encodeURIComponent('' + includeProject) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSiteById(_response);
        });
    }

    protected processGetSiteById(response: Response): Promise<SiteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SiteDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateSite(id: number, body: SiteDto | undefined): Promise<SiteDto> {
        let url_ = this.baseUrl + '/api/Site/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSite(_response);
        });
    }

    protected processUpdateSite(response: Response): Promise<SiteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SiteDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteSite(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Site/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSite(_response);
        });
    }

    protected processDeleteSite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewSite(projectId: number, body: SiteDto | undefined): Promise<SiteDto> {
        let url_ = this.baseUrl + '/api/Site/{projectId}';
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewSite(_response);
        });
    }

    protected processAddNewSite(response: Response): Promise<SiteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SiteDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getAllSituationsForSite(siteId: number): Promise<SituationDto[]> {
        let url_ = this.baseUrl + '/api/Situation/forSite/{siteId}';
        if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace('{siteId}', encodeURIComponent('' + siteId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSituationsForSite(_response);
        });
    }

    protected processGetAllSituationsForSite(response: Response): Promise<SituationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(SituationDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<SituationDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewSituationForSite(siteId: number, body: SituationDto | undefined): Promise<SituationDto> {
        let url_ = this.baseUrl + '/api/Situation/forSite/{siteId}';
        if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace('{siteId}', encodeURIComponent('' + siteId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewSituationForSite(_response);
        });
    }

    protected processAddNewSituationForSite(response: Response): Promise<SituationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SituationDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    getSituationById(id: number): Promise<SituationDto> {
        let url_ = this.baseUrl + '/api/Situation/byId/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSituationById(_response);
        });
    }

    protected processGetSituationById(response: Response): Promise<SituationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SituationDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<SituationDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateSituation(id: number, body: SituationDto | undefined): Promise<SituationDto> {
        let url_ = this.baseUrl + '/api/Situation/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSituation(_response);
        });
    }

    protected processUpdateSituation(response: Response): Promise<SituationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SituationDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteSituation(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Situation/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSituation(_response);
        });
    }

    protected processDeleteSituation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getHelloWorld(): Promise<string> {
        let url_ = this.baseUrl + '/api/Test/helloWorld';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHelloWorld(_response);
        });
    }

    protected processGetHelloWorld(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param name (optional)
     * @return OK
     */
    getHelloYou(name: string | undefined): Promise<string> {
        let url_ = this.baseUrl + '/api/Test/helloYou?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHelloYou(_response);
        });
    }

    protected processGetHelloYou(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getHelloSuperAdmin(): Promise<string> {
        let url_ = this.baseUrl + '/api/Test/helloSuperAdmin';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHelloSuperAdmin(_response);
        });
    }

    protected processGetHelloSuperAdmin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getHelloSystemAdmin(): Promise<string> {
        let url_ = this.baseUrl + '/api/Test/helloSystemAdmin';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHelloSystemAdmin(_response);
        });
    }

    protected processGetHelloSystemAdmin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getHelloEmployee(): Promise<string> {
        let url_ = this.baseUrl + '/api/Test/helloEmployee';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHelloEmployee(_response);
        });
    }

    protected processGetHelloEmployee(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getHelloCEO(): Promise<string> {
        let url_ = this.baseUrl + '/api/Test/helloCEO';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHelloCEO(_response);
        });
    }

    protected processGetHelloCEO(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getAllWaybills(includeOrder: boolean | undefined): Promise<WaybillDto[]> {
        let url_ = this.baseUrl + '/api/Waybill/all?';
        if (includeOrder === null) throw new Error("The parameter 'includeOrder' cannot be null.");
        else if (includeOrder !== undefined) url_ += 'includeOrder=' + encodeURIComponent('' + includeOrder) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWaybills(_response);
        });
    }

    protected processGetAllWaybills(response: Response): Promise<WaybillDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(WaybillDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<WaybillDto[]>(null as any);
    }

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getWaybill(id: number, includeOrder: boolean | undefined): Promise<WaybillDto> {
        let url_ = this.baseUrl + '/api/Waybill/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (includeOrder === null) throw new Error("The parameter 'includeOrder' cannot be null.");
        else if (includeOrder !== undefined) url_ += 'includeOrder=' + encodeURIComponent('' + includeOrder) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWaybill(_response);
        });
    }

    protected processGetWaybill(response: Response): Promise<WaybillDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WaybillDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<WaybillDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    updateWaybill(id: number, body: WaybillDto | undefined): Promise<WaybillDto> {
        let url_ = this.baseUrl + '/api/Waybill/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWaybill(_response);
        });
    }

    protected processUpdateWaybill(response: Response): Promise<WaybillDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WaybillDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return OK
     */
    deleteWaybill(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/Waybill/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWaybill(_response);
        });
    }

    protected processDeleteWaybill(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409: any = null;
                let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ConcurrencyRequestResponse.fromJS(resultData409);
                return throwException('Conflict', status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getFullWaybillInfo(id: number): Promise<WaybillFullInfoDto> {
        let url_ = this.baseUrl + '/api/Waybill/fullInfo/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFullWaybillInfo(_response);
        });
    }

    protected processGetFullWaybillInfo(response: Response): Promise<WaybillFullInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WaybillFullInfoDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<WaybillFullInfoDto>(null as any);
    }

    /**
     * @param includeOrder (optional)
     * @return OK
     */
    getWaybillForOrder(orderId: number, includeOrder: boolean | undefined): Promise<WaybillDto> {
        let url_ = this.baseUrl + '/api/Waybill/forOrder/{orderId}?';
        if (orderId === undefined || orderId === null) throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
        if (includeOrder === null) throw new Error("The parameter 'includeOrder' cannot be null.");
        else if (includeOrder !== undefined) url_ += 'includeOrder=' + encodeURIComponent('' + includeOrder) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWaybillForOrder(_response);
        });
    }

    protected processGetWaybillForOrder(response: Response): Promise<WaybillDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WaybillDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = BadRequestResponse.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<WaybillDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    addNewWaybill(body: WaybillDto | undefined): Promise<WaybillDto> {
        let url_ = this.baseUrl + '/api/Waybill';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewWaybill(_response);
        });
    }

    protected processAddNewWaybill(response: Response): Promise<WaybillDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WaybillDto.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException('Bad Request', status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                let resultDatadefault = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException('Error', status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class ArticleDto implements IArticleDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    title?: string | undefined;
    manufacturer?: string | undefined;
    calculatedAveragePrice?: number | undefined;
    dimensionType?: DimensionType;
    innerCode?: string | undefined;
    outterCode?: string | undefined;
    description?: string | undefined;
    labels?: LabelDto[] | undefined;
    data?: any | undefined;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.title = _data['title'];
            this.manufacturer = _data['manufacturer'];
            this.calculatedAveragePrice = _data['calculatedAveragePrice'];
            this.dimensionType = _data['dimensionType'];
            this.innerCode = _data['innerCode'];
            this.outterCode = _data['outterCode'];
            this.description = _data['description'];
            if (Array.isArray(_data['labels'])) {
                this.labels = [] as any;
                for (let item of _data['labels']) this.labels!.push(LabelDto.fromJS(item));
            }
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['title'] = this.title;
        data['manufacturer'] = this.manufacturer;
        data['calculatedAveragePrice'] = this.calculatedAveragePrice;
        data['dimensionType'] = this.dimensionType;
        data['innerCode'] = this.innerCode;
        data['outterCode'] = this.outterCode;
        data['description'] = this.description;
        if (Array.isArray(this.labels)) {
            data['labels'] = [];
            for (let item of this.labels) data['labels'].push(item.toJSON());
        }
        data['data'] = this.data;
        return data;
    }
}

export interface IArticleDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    title?: string | undefined;
    manufacturer?: string | undefined;
    calculatedAveragePrice?: number | undefined;
    dimensionType?: DimensionType;
    innerCode?: string | undefined;
    outterCode?: string | undefined;
    description?: string | undefined;
    labels?: LabelDto[] | undefined;
    data?: any | undefined;
}

export class BadRequestResponse implements IBadRequestResponse {
    readonly messageCode?: string | undefined;
    readonly messageValue?: string | undefined;

    constructor(data?: IBadRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data['messageCode'];
            (<any>this).messageValue = _data['messageValue'];
        }
    }

    static fromJS(data: any): BadRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['messageCode'] = this.messageCode;
        data['messageValue'] = this.messageValue;
        return data;
    }
}

export interface IBadRequestResponse {
    messageCode?: string | undefined;
    messageValue?: string | undefined;
}

export class BatchDto implements IBatchDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    uniqueBatchId?: string | undefined;
    supplier?: ClientDto;
    supplierId?: number | undefined;
    purchasePricePerArticle?: number;
    batchArrivalTime?: Date | undefined;

    constructor(data?: IBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.uniqueBatchId = _data['uniqueBatchId'];
            this.supplier = _data['supplier'] ? ClientDto.fromJS(_data['supplier']) : <any>undefined;
            this.supplierId = _data['supplierId'];
            this.purchasePricePerArticle = _data['purchasePricePerArticle'];
            this.batchArrivalTime = _data['batchArrivalTime']
                ? new Date(_data['batchArrivalTime'].toString())
                : <any>undefined;
        }
    }

    static fromJS(data: any): BatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['uniqueBatchId'] = this.uniqueBatchId;
        data['supplier'] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data['supplierId'] = this.supplierId;
        data['purchasePricePerArticle'] = this.purchasePricePerArticle;
        data['batchArrivalTime'] = this.batchArrivalTime ? this.batchArrivalTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatchDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    uniqueBatchId?: string | undefined;
    supplier?: ClientDto;
    supplierId?: number | undefined;
    purchasePricePerArticle?: number;
    batchArrivalTime?: Date | undefined;
}

export class ChangeDemandOrderStatusDto implements IChangeDemandOrderStatusDto {
    order?: DemandOrderDto;
    newOrderStatus?: SpecializedOrderStatus;

    constructor(data?: IChangeDemandOrderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data['order'] ? DemandOrderDto.fromJS(_data['order']) : <any>undefined;
            this.newOrderStatus = _data['newOrderStatus'];
        }
    }

    static fromJS(data: any): ChangeDemandOrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDemandOrderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['newOrderStatus'] = this.newOrderStatus;
        return data;
    }
}

export interface IChangeDemandOrderStatusDto {
    order?: DemandOrderDto;
    newOrderStatus?: SpecializedOrderStatus;
}

export class ChangeOrderStatusDto implements IChangeOrderStatusDto {
    order?: OrderDto;
    newOrderStatus?: OrderStatus;

    constructor(data?: IChangeOrderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data['order'] ? OrderDto.fromJS(_data['order']) : <any>undefined;
            this.newOrderStatus = _data['newOrderStatus'];
        }
    }

    static fromJS(data: any): ChangeOrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeOrderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['newOrderStatus'] = this.newOrderStatus;
        return data;
    }
}

export interface IChangeOrderStatusDto {
    order?: OrderDto;
    newOrderStatus?: OrderStatus;
}

export class ChangePurchaseOrderStatusDto implements IChangePurchaseOrderStatusDto {
    order?: PurchaseOrderDto;
    newOrderStatus?: SpecializedOrderStatus;

    constructor(data?: IChangePurchaseOrderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data['order'] ? PurchaseOrderDto.fromJS(_data['order']) : <any>undefined;
            this.newOrderStatus = _data['newOrderStatus'];
        }
    }

    static fromJS(data: any): ChangePurchaseOrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePurchaseOrderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['newOrderStatus'] = this.newOrderStatus;
        return data;
    }
}

export interface IChangePurchaseOrderStatusDto {
    order?: PurchaseOrderDto;
    newOrderStatus?: SpecializedOrderStatus;
}

export class ChangeReturnOrderStatusDto implements IChangeReturnOrderStatusDto {
    order?: ReturnOrderDto;
    newOrderStatus?: SpecializedOrderStatus;

    constructor(data?: IChangeReturnOrderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data['order'] ? ReturnOrderDto.fromJS(_data['order']) : <any>undefined;
            this.newOrderStatus = _data['newOrderStatus'];
        }
    }

    static fromJS(data: any): ChangeReturnOrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeReturnOrderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['newOrderStatus'] = this.newOrderStatus;
        return data;
    }
}

export interface IChangeReturnOrderStatusDto {
    order?: ReturnOrderDto;
    newOrderStatus?: SpecializedOrderStatus;
}

export class ClientDto implements IClientDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    entityType?: EntityType;
    clientType?: ClientType;
    name?: string | undefined;
    shortName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    ucin?: string | undefined;
    taxId?: string | undefined;
    contactInfo?: string | undefined;
    email?: string | undefined;
    batches?: BatchDto[] | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.entityType = _data['entityType'];
            this.clientType = _data['clientType'];
            this.name = _data['name'];
            this.shortName = _data['shortName'];
            this.phone = _data['phone'];
            this.address = _data['address'];
            this.state = _data['state'];
            this.city = _data['city'];
            this.ucin = _data['ucin'];
            this.taxId = _data['taxId'];
            this.contactInfo = _data['contactInfo'];
            this.email = _data['email'];
            if (Array.isArray(_data['batches'])) {
                this.batches = [] as any;
                for (let item of _data['batches']) this.batches!.push(BatchDto.fromJS(item));
            }
            if (Array.isArray(_data['purchaseOrders'])) {
                this.purchaseOrders = [] as any;
                for (let item of _data['purchaseOrders']) this.purchaseOrders!.push(PurchaseOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['entityType'] = this.entityType;
        data['clientType'] = this.clientType;
        data['name'] = this.name;
        data['shortName'] = this.shortName;
        data['phone'] = this.phone;
        data['address'] = this.address;
        data['state'] = this.state;
        data['city'] = this.city;
        data['ucin'] = this.ucin;
        data['taxId'] = this.taxId;
        data['contactInfo'] = this.contactInfo;
        data['email'] = this.email;
        if (Array.isArray(this.batches)) {
            data['batches'] = [];
            for (let item of this.batches) data['batches'].push(item.toJSON());
        }
        if (Array.isArray(this.purchaseOrders)) {
            data['purchaseOrders'] = [];
            for (let item of this.purchaseOrders) data['purchaseOrders'].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    entityType?: EntityType;
    clientType?: ClientType;
    name?: string | undefined;
    shortName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    ucin?: string | undefined;
    taxId?: string | undefined;
    contactInfo?: string | undefined;
    email?: string | undefined;
    batches?: BatchDto[] | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
}

export enum ClientType {
    Customer = 'Customer',
    Supplier = 'Supplier',
}

export class CommonInfoDto implements ICommonInfoDto {
    googleMapsApiKey?: string | undefined;

    constructor(data?: ICommonInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleMapsApiKey = _data['googleMapsApiKey'];
        }
    }

    static fromJS(data: any): CommonInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommonInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['googleMapsApiKey'] = this.googleMapsApiKey;
        return data;
    }
}

export interface ICommonInfoDto {
    googleMapsApiKey?: string | undefined;
}

export class CompanyDetailsDto implements ICompanyDetailsDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    name?: string | undefined;
    currency?: string | undefined;
    documentCompanyDetails?: any | undefined;
    documentReceiverTemplate?: any | undefined;

    constructor(data?: ICompanyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.name = _data['name'];
            this.currency = _data['currency'];
            this.documentCompanyDetails = _data['documentCompanyDetails'];
            this.documentReceiverTemplate = _data['documentReceiverTemplate'];
        }
    }

    static fromJS(data: any): CompanyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['name'] = this.name;
        data['currency'] = this.currency;
        data['documentCompanyDetails'] = this.documentCompanyDetails;
        data['documentReceiverTemplate'] = this.documentReceiverTemplate;
        return data;
    }
}

export interface ICompanyDetailsDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    name?: string | undefined;
    currency?: string | undefined;
    documentCompanyDetails?: any | undefined;
    documentReceiverTemplate?: any | undefined;
}

export class ConcurrencyRequestResponse implements IConcurrencyRequestResponse {
    readonly messageCode?: string | undefined;
    readonly messageValue?: string | undefined;

    constructor(data?: IConcurrencyRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data['messageCode'];
            (<any>this).messageValue = _data['messageValue'];
        }
    }

    static fromJS(data: any): ConcurrencyRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConcurrencyRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['messageCode'] = this.messageCode;
        data['messageValue'] = this.messageValue;
        return data;
    }
}

export interface IConcurrencyRequestResponse {
    messageCode?: string | undefined;
    messageValue?: string | undefined;
}

export class DemandOrderDataDto implements IDemandOrderDataDto {
    orders?: DemandOrderDto[] | undefined;
    infoDate?: Date;

    constructor(data?: IDemandOrderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders!.push(DemandOrderDto.fromJS(item));
            }
            this.infoDate = _data['infoDate'] ? new Date(_data['infoDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DemandOrderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemandOrderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['infoDate'] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDemandOrderDataDto {
    orders?: DemandOrderDto[] | undefined;
    infoDate?: Date;
}

export class DemandOrderDto implements IDemandOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    destinationSiteId?: number | undefined;
    destinationSite?: SiteDto;
    orderGoodsItems?: OrderGoodsItemDto[] | undefined;
    orders?: OrderDto[] | undefined;
    demandOrderStatus?: SpecializedOrderStatus;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IDemandOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.destinationSiteId = _data['destinationSiteId'];
            this.destinationSite = _data['destinationSite'] ? SiteDto.fromJS(_data['destinationSite']) : <any>undefined;
            if (Array.isArray(_data['orderGoodsItems'])) {
                this.orderGoodsItems = [] as any;
                for (let item of _data['orderGoodsItems']) this.orderGoodsItems!.push(OrderGoodsItemDto.fromJS(item));
            }
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders!.push(OrderDto.fromJS(item));
            }
            this.demandOrderStatus = _data['demandOrderStatus'];
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): DemandOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemandOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['destinationSiteId'] = this.destinationSiteId;
        data['destinationSite'] = this.destinationSite ? this.destinationSite.toJSON() : <any>undefined;
        if (Array.isArray(this.orderGoodsItems)) {
            data['orderGoodsItems'] = [];
            for (let item of this.orderGoodsItems) data['orderGoodsItems'].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['demandOrderStatus'] = this.demandOrderStatus;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface IDemandOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    destinationSiteId?: number | undefined;
    destinationSite?: SiteDto;
    orderGoodsItems?: OrderGoodsItemDto[] | undefined;
    orders?: OrderDto[] | undefined;
    demandOrderStatus?: SpecializedOrderStatus;
    description?: string | undefined;
    data?: any | undefined;
}

export enum DimensionType {
    Quantity = 'Quantity',
    Weight = 'Weight',
    Length = 'Length',
}

export class EmployeeDto implements IEmployeeDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    azObjId?: string | undefined;
    data?: any | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.azObjId = _data['azObjId'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['azObjId'] = this.azObjId;
        data['data'] = this.data;
        return data;
    }
}

export interface IEmployeeDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    azObjId?: string | undefined;
    data?: any | undefined;
}

export enum EntityType {
    Legal = 'Legal',
    Physical = 'Physical',
}

export class GetOrdersDataRefreshInfoResponseDto implements IGetOrdersDataRefreshInfoResponseDto {
    infoDate?: Date | undefined;

    constructor(data?: IGetOrdersDataRefreshInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoDate = _data['infoDate'] ? new Date(_data['infoDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrdersDataRefreshInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersDataRefreshInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['infoDate'] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetOrdersDataRefreshInfoResponseDto {
    infoDate?: Date | undefined;
}

export class GoodsBatchItemDto implements IGoodsBatchItemDto {
    articleId?: number;
    quantity?: number;
    purchasePricePerArticle?: number | undefined;
    goodsStatus?: GoodsStatus;
    data?: any | undefined;
    siteId?: number;
    batchId?: number | undefined;
    uniqueBatchId?: string | undefined;
    supplierId?: number | undefined;
    purchaseOrderId?: number | undefined;
    batchArrivalTime?: Date | undefined;

    constructor(data?: IGoodsBatchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data['articleId'];
            this.quantity = _data['quantity'];
            this.purchasePricePerArticle = _data['purchasePricePerArticle'];
            this.goodsStatus = _data['goodsStatus'];
            this.data = _data['data'];
            this.siteId = _data['siteId'];
            this.batchId = _data['batchId'];
            this.uniqueBatchId = _data['uniqueBatchId'];
            this.supplierId = _data['supplierId'];
            this.purchaseOrderId = _data['purchaseOrderId'];
            this.batchArrivalTime = _data['batchArrivalTime']
                ? new Date(_data['batchArrivalTime'].toString())
                : <any>undefined;
        }
    }

    static fromJS(data: any): GoodsBatchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsBatchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['articleId'] = this.articleId;
        data['quantity'] = this.quantity;
        data['purchasePricePerArticle'] = this.purchasePricePerArticle;
        data['goodsStatus'] = this.goodsStatus;
        data['data'] = this.data;
        data['siteId'] = this.siteId;
        data['batchId'] = this.batchId;
        data['uniqueBatchId'] = this.uniqueBatchId;
        data['supplierId'] = this.supplierId;
        data['purchaseOrderId'] = this.purchaseOrderId;
        data['batchArrivalTime'] = this.batchArrivalTime ? this.batchArrivalTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGoodsBatchItemDto {
    articleId?: number;
    quantity?: number;
    purchasePricePerArticle?: number | undefined;
    goodsStatus?: GoodsStatus;
    data?: any | undefined;
    siteId?: number;
    batchId?: number | undefined;
    uniqueBatchId?: string | undefined;
    supplierId?: number | undefined;
    purchaseOrderId?: number | undefined;
    batchArrivalTime?: Date | undefined;
}

export class GoodsDto implements IGoodsDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    quantity?: number;
    goodsStatus?: GoodsStatus;
    data?: any | undefined;
    siteId?: number;
    site?: SiteDto;
    article?: ArticleDto;
    batch?: BatchDto;
    exitInfo?: GoodsExitInfoDto;
    purchaseOrder?: PurchaseOrderDto;

    constructor(data?: IGoodsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.quantity = _data['quantity'];
            this.goodsStatus = _data['goodsStatus'];
            this.data = _data['data'];
            this.siteId = _data['siteId'];
            this.site = _data['site'] ? SiteDto.fromJS(_data['site']) : <any>undefined;
            this.article = _data['article'] ? ArticleDto.fromJS(_data['article']) : <any>undefined;
            this.batch = _data['batch'] ? BatchDto.fromJS(_data['batch']) : <any>undefined;
            this.exitInfo = _data['exitInfo'] ? GoodsExitInfoDto.fromJS(_data['exitInfo']) : <any>undefined;
            this.purchaseOrder = _data['purchaseOrder']
                ? PurchaseOrderDto.fromJS(_data['purchaseOrder'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): GoodsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['quantity'] = this.quantity;
        data['goodsStatus'] = this.goodsStatus;
        data['data'] = this.data;
        data['siteId'] = this.siteId;
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        data['article'] = this.article ? this.article.toJSON() : <any>undefined;
        data['batch'] = this.batch ? this.batch.toJSON() : <any>undefined;
        data['exitInfo'] = this.exitInfo ? this.exitInfo.toJSON() : <any>undefined;
        data['purchaseOrder'] = this.purchaseOrder ? this.purchaseOrder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGoodsDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    quantity?: number;
    goodsStatus?: GoodsStatus;
    data?: any | undefined;
    siteId?: number;
    site?: SiteDto;
    article?: ArticleDto;
    batch?: BatchDto;
    exitInfo?: GoodsExitInfoDto;
    purchaseOrder?: PurchaseOrderDto;
}

export class GoodsExitInfoDto implements IGoodsExitInfoDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    goods?: GoodsDto[] | undefined;
    oldStatus?: GoodsStatus;
    newStatus?: GoodsStatus;
    soldToId?: number | undefined;
    soldTo?: ClientDto;
    sellingPrice?: number | undefined;
    orderId?: number | undefined;
    order?: OrderDto;
    reason?: string | undefined;
    situationId?: number | undefined;
    situation?: SituationDto;
    executionTime?: Date | undefined;
    data?: any | undefined;

    constructor(data?: IGoodsExitInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            if (Array.isArray(_data['goods'])) {
                this.goods = [] as any;
                for (let item of _data['goods']) this.goods!.push(GoodsDto.fromJS(item));
            }
            this.oldStatus = _data['oldStatus'];
            this.newStatus = _data['newStatus'];
            this.soldToId = _data['soldToId'];
            this.soldTo = _data['soldTo'] ? ClientDto.fromJS(_data['soldTo']) : <any>undefined;
            this.sellingPrice = _data['sellingPrice'];
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? OrderDto.fromJS(_data['order']) : <any>undefined;
            this.reason = _data['reason'];
            this.situationId = _data['situationId'];
            this.situation = _data['situation'] ? SituationDto.fromJS(_data['situation']) : <any>undefined;
            this.executionTime = _data['executionTime'] ? new Date(_data['executionTime'].toString()) : <any>undefined;
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): GoodsExitInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsExitInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        if (Array.isArray(this.goods)) {
            data['goods'] = [];
            for (let item of this.goods) data['goods'].push(item.toJSON());
        }
        data['oldStatus'] = this.oldStatus;
        data['newStatus'] = this.newStatus;
        data['soldToId'] = this.soldToId;
        data['soldTo'] = this.soldTo ? this.soldTo.toJSON() : <any>undefined;
        data['sellingPrice'] = this.sellingPrice;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['reason'] = this.reason;
        data['situationId'] = this.situationId;
        data['situation'] = this.situation ? this.situation.toJSON() : <any>undefined;
        data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data['data'] = this.data;
        return data;
    }
}

export interface IGoodsExitInfoDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    goods?: GoodsDto[] | undefined;
    oldStatus?: GoodsStatus;
    newStatus?: GoodsStatus;
    soldToId?: number | undefined;
    soldTo?: ClientDto;
    sellingPrice?: number | undefined;
    orderId?: number | undefined;
    order?: OrderDto;
    reason?: string | undefined;
    situationId?: number | undefined;
    situation?: SituationDto;
    executionTime?: Date | undefined;
    data?: any | undefined;
}

export class GoodsManipulationItemDto implements IGoodsManipulationItemDto {
    quantity?: number;
    isInTransport?: boolean;
    targetStatus?: GoodsStatus;
    articleId?: number;
    goodsOriginSiteId?: number | undefined;
    goodsOriginOrderId?: number | undefined;
    soldToClientId?: number | undefined;
    sellingPrice?: number | undefined;
    usedOnSituationId?: number | undefined;
    reason?: string | undefined;
    executionTime?: Date | undefined;

    constructor(data?: IGoodsManipulationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data['quantity'];
            this.isInTransport = _data['isInTransport'];
            this.targetStatus = _data['targetStatus'];
            this.articleId = _data['articleId'];
            this.goodsOriginSiteId = _data['goodsOriginSiteId'];
            this.goodsOriginOrderId = _data['goodsOriginOrderId'];
            this.soldToClientId = _data['soldToClientId'];
            this.sellingPrice = _data['sellingPrice'];
            this.usedOnSituationId = _data['usedOnSituationId'];
            this.reason = _data['reason'];
            this.executionTime = _data['executionTime'] ? new Date(_data['executionTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GoodsManipulationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsManipulationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quantity'] = this.quantity;
        data['isInTransport'] = this.isInTransport;
        data['targetStatus'] = this.targetStatus;
        data['articleId'] = this.articleId;
        data['goodsOriginSiteId'] = this.goodsOriginSiteId;
        data['goodsOriginOrderId'] = this.goodsOriginOrderId;
        data['soldToClientId'] = this.soldToClientId;
        data['sellingPrice'] = this.sellingPrice;
        data['usedOnSituationId'] = this.usedOnSituationId;
        data['reason'] = this.reason;
        data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGoodsManipulationItemDto {
    quantity?: number;
    isInTransport?: boolean;
    targetStatus?: GoodsStatus;
    articleId?: number;
    goodsOriginSiteId?: number | undefined;
    goodsOriginOrderId?: number | undefined;
    soldToClientId?: number | undefined;
    sellingPrice?: number | undefined;
    usedOnSituationId?: number | undefined;
    reason?: string | undefined;
    executionTime?: Date | undefined;
}

export enum GoodsStatus {
    WrittenOff = 'WrittenOff',
    Used = 'Used',
    Sold = 'Sold',
    InStock = 'InStock',
    InTransport = 'InTransport',
    Ordered = 'Ordered',
}

export enum LabelCategory {
    Article = 'Article',
}

export class LabelDto implements ILabelDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    title?: string | undefined;
    labelCategory?: LabelCategory;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: ILabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.title = _data['title'];
            this.labelCategory = _data['labelCategory'];
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): LabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['title'] = this.title;
        data['labelCategory'] = this.labelCategory;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface ILabelDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    title?: string | undefined;
    labelCategory?: LabelCategory;
    description?: string | undefined;
    data?: any | undefined;
}

export class OrderDataDto implements IOrderDataDto {
    orders?: OrderDto[] | undefined;
    infoDate?: Date;

    constructor(data?: IOrderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders!.push(OrderDto.fromJS(item));
            }
            this.infoDate = _data['infoDate'] ? new Date(_data['infoDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['infoDate'] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderDataDto {
    orders?: OrderDto[] | undefined;
    infoDate?: Date;
}

export class OrderDto implements IOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    goodsIds?: number[] | undefined;
    goods?: GoodsDto[] | undefined;
    supplierId?: number | undefined;
    supplier?: ClientDto;
    originSiteId?: number | undefined;
    originSite?: SiteDto;
    destinationSiteId?: number | undefined;
    destinationSite?: SiteDto;
    waybill?: WaybillDto;
    receipts?: ReceiptDto[] | undefined;
    orderGoodsItems?: OrderGoodsItemDto[] | undefined;
    orderStatus?: OrderStatus;
    isExpress?: boolean;
    demandOrderId?: number | undefined;
    demandOrder?: DemandOrderDto;
    returnOrderId?: number | undefined;
    returnOrder?: ReturnOrderDto;
    purchaseOrderId?: number | undefined;
    purchaseOrder?: PurchaseOrderDto;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            if (Array.isArray(_data['goodsIds'])) {
                this.goodsIds = [] as any;
                for (let item of _data['goodsIds']) this.goodsIds!.push(item);
            }
            if (Array.isArray(_data['goods'])) {
                this.goods = [] as any;
                for (let item of _data['goods']) this.goods!.push(GoodsDto.fromJS(item));
            }
            this.supplierId = _data['supplierId'];
            this.supplier = _data['supplier'] ? ClientDto.fromJS(_data['supplier']) : <any>undefined;
            this.originSiteId = _data['originSiteId'];
            this.originSite = _data['originSite'] ? SiteDto.fromJS(_data['originSite']) : <any>undefined;
            this.destinationSiteId = _data['destinationSiteId'];
            this.destinationSite = _data['destinationSite'] ? SiteDto.fromJS(_data['destinationSite']) : <any>undefined;
            this.waybill = _data['waybill'] ? WaybillDto.fromJS(_data['waybill']) : <any>undefined;
            if (Array.isArray(_data['receipts'])) {
                this.receipts = [] as any;
                for (let item of _data['receipts']) this.receipts!.push(ReceiptDto.fromJS(item));
            }
            if (Array.isArray(_data['orderGoodsItems'])) {
                this.orderGoodsItems = [] as any;
                for (let item of _data['orderGoodsItems']) this.orderGoodsItems!.push(OrderGoodsItemDto.fromJS(item));
            }
            this.orderStatus = _data['orderStatus'];
            this.isExpress = _data['isExpress'];
            this.demandOrderId = _data['demandOrderId'];
            this.demandOrder = _data['demandOrder'] ? DemandOrderDto.fromJS(_data['demandOrder']) : <any>undefined;
            this.returnOrderId = _data['returnOrderId'];
            this.returnOrder = _data['returnOrder'] ? ReturnOrderDto.fromJS(_data['returnOrder']) : <any>undefined;
            this.purchaseOrderId = _data['purchaseOrderId'];
            this.purchaseOrder = _data['purchaseOrder']
                ? PurchaseOrderDto.fromJS(_data['purchaseOrder'])
                : <any>undefined;
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        if (Array.isArray(this.goodsIds)) {
            data['goodsIds'] = [];
            for (let item of this.goodsIds) data['goodsIds'].push(item);
        }
        if (Array.isArray(this.goods)) {
            data['goods'] = [];
            for (let item of this.goods) data['goods'].push(item.toJSON());
        }
        data['supplierId'] = this.supplierId;
        data['supplier'] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data['originSiteId'] = this.originSiteId;
        data['originSite'] = this.originSite ? this.originSite.toJSON() : <any>undefined;
        data['destinationSiteId'] = this.destinationSiteId;
        data['destinationSite'] = this.destinationSite ? this.destinationSite.toJSON() : <any>undefined;
        data['waybill'] = this.waybill ? this.waybill.toJSON() : <any>undefined;
        if (Array.isArray(this.receipts)) {
            data['receipts'] = [];
            for (let item of this.receipts) data['receipts'].push(item.toJSON());
        }
        if (Array.isArray(this.orderGoodsItems)) {
            data['orderGoodsItems'] = [];
            for (let item of this.orderGoodsItems) data['orderGoodsItems'].push(item.toJSON());
        }
        data['orderStatus'] = this.orderStatus;
        data['isExpress'] = this.isExpress;
        data['demandOrderId'] = this.demandOrderId;
        data['demandOrder'] = this.demandOrder ? this.demandOrder.toJSON() : <any>undefined;
        data['returnOrderId'] = this.returnOrderId;
        data['returnOrder'] = this.returnOrder ? this.returnOrder.toJSON() : <any>undefined;
        data['purchaseOrderId'] = this.purchaseOrderId;
        data['purchaseOrder'] = this.purchaseOrder ? this.purchaseOrder.toJSON() : <any>undefined;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface IOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    goodsIds?: number[] | undefined;
    goods?: GoodsDto[] | undefined;
    supplierId?: number | undefined;
    supplier?: ClientDto;
    originSiteId?: number | undefined;
    originSite?: SiteDto;
    destinationSiteId?: number | undefined;
    destinationSite?: SiteDto;
    waybill?: WaybillDto;
    receipts?: ReceiptDto[] | undefined;
    orderGoodsItems?: OrderGoodsItemDto[] | undefined;
    orderStatus?: OrderStatus;
    isExpress?: boolean;
    demandOrderId?: number | undefined;
    demandOrder?: DemandOrderDto;
    returnOrderId?: number | undefined;
    returnOrder?: ReturnOrderDto;
    purchaseOrderId?: number | undefined;
    purchaseOrder?: PurchaseOrderDto;
    description?: string | undefined;
    data?: any | undefined;
}

export class OrderGoodsItemDto implements IOrderGoodsItemDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    quantity?: number;
    dataJson?: string | undefined;
    articleId?: number;
    article?: ArticleDto;
    orderId?: number | undefined;
    order?: OrderDto;
    demandOrderId?: number | undefined;
    demandOrder?: DemandOrderDto;
    returnOrderId?: number | undefined;
    returnOrder?: ReturnOrderDto;
    data?: any | undefined;

    constructor(data?: IOrderGoodsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.quantity = _data['quantity'];
            this.dataJson = _data['dataJson'];
            this.articleId = _data['articleId'];
            this.article = _data['article'] ? ArticleDto.fromJS(_data['article']) : <any>undefined;
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? OrderDto.fromJS(_data['order']) : <any>undefined;
            this.demandOrderId = _data['demandOrderId'];
            this.demandOrder = _data['demandOrder'] ? DemandOrderDto.fromJS(_data['demandOrder']) : <any>undefined;
            this.returnOrderId = _data['returnOrderId'];
            this.returnOrder = _data['returnOrder'] ? ReturnOrderDto.fromJS(_data['returnOrder']) : <any>undefined;
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): OrderGoodsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGoodsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['quantity'] = this.quantity;
        data['dataJson'] = this.dataJson;
        data['articleId'] = this.articleId;
        data['article'] = this.article ? this.article.toJSON() : <any>undefined;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['demandOrderId'] = this.demandOrderId;
        data['demandOrder'] = this.demandOrder ? this.demandOrder.toJSON() : <any>undefined;
        data['returnOrderId'] = this.returnOrderId;
        data['returnOrder'] = this.returnOrder ? this.returnOrder.toJSON() : <any>undefined;
        data['data'] = this.data;
        return data;
    }
}

export interface IOrderGoodsItemDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    quantity?: number;
    dataJson?: string | undefined;
    articleId?: number;
    article?: ArticleDto;
    orderId?: number | undefined;
    order?: OrderDto;
    demandOrderId?: number | undefined;
    demandOrder?: DemandOrderDto;
    returnOrderId?: number | undefined;
    returnOrder?: ReturnOrderDto;
    data?: any | undefined;
}

export enum OrderStatus {
    Idle = 'Idle',
    Pending = 'Pending',
    Approved = 'Approved',
    Transport = 'Transport',
    Delivered = 'Delivered',
    Returned = 'Returned',
    Cancelled = 'Cancelled',
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.type = _data['type'];
            this.title = _data['title'];
            this.status = _data['status'];
            this.detail = _data['detail'];
            this.instance = _data['instance'];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data['type'] = this.type;
        data['title'] = this.title;
        data['status'] = this.status;
        data['detail'] = this.detail;
        data['instance'] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProjectDto implements IProjectDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    name?: string | undefined;
    sites?: SiteDto[] | undefined;
    clientId?: number;
    client?: ClientDto;
    projectManagersAzObjIds?: string[] | undefined;
    data?: any | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.name = _data['name'];
            if (Array.isArray(_data['sites'])) {
                this.sites = [] as any;
                for (let item of _data['sites']) this.sites!.push(SiteDto.fromJS(item));
            }
            this.clientId = _data['clientId'];
            this.client = _data['client'] ? ClientDto.fromJS(_data['client']) : <any>undefined;
            if (Array.isArray(_data['projectManagersAzObjIds'])) {
                this.projectManagersAzObjIds = [] as any;
                for (let item of _data['projectManagersAzObjIds']) this.projectManagersAzObjIds!.push(item);
            }
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['name'] = this.name;
        if (Array.isArray(this.sites)) {
            data['sites'] = [];
            for (let item of this.sites) data['sites'].push(item.toJSON());
        }
        data['clientId'] = this.clientId;
        data['client'] = this.client ? this.client.toJSON() : <any>undefined;
        if (Array.isArray(this.projectManagersAzObjIds)) {
            data['projectManagersAzObjIds'] = [];
            for (let item of this.projectManagersAzObjIds) data['projectManagersAzObjIds'].push(item);
        }
        data['data'] = this.data;
        return data;
    }
}

export interface IProjectDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    name?: string | undefined;
    sites?: SiteDto[] | undefined;
    clientId?: number;
    client?: ClientDto;
    projectManagersAzObjIds?: string[] | undefined;
    data?: any | undefined;
}

export class PurchaseOrderDataDto implements IPurchaseOrderDataDto {
    orders?: PurchaseOrderDto[] | undefined;
    infoDate?: Date;

    constructor(data?: IPurchaseOrderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders!.push(PurchaseOrderDto.fromJS(item));
            }
            this.infoDate = _data['infoDate'] ? new Date(_data['infoDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseOrderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['infoDate'] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPurchaseOrderDataDto {
    orders?: PurchaseOrderDto[] | undefined;
    infoDate?: Date;
}

export class PurchaseOrderDto implements IPurchaseOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    documentCode?: string | undefined;
    goods?: GoodsDto[] | undefined;
    supplierId?: number | undefined;
    supplier?: ClientDto;
    destinationSiteId?: number | undefined;
    destinationSite?: SiteDto;
    receptionOrdersIds?: number[] | undefined;
    receptionOrders?: OrderDto[] | undefined;
    purchaseOrderStatus?: SpecializedOrderStatus;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IPurchaseOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.documentCode = _data['documentCode'];
            if (Array.isArray(_data['goods'])) {
                this.goods = [] as any;
                for (let item of _data['goods']) this.goods!.push(GoodsDto.fromJS(item));
            }
            this.supplierId = _data['supplierId'];
            this.supplier = _data['supplier'] ? ClientDto.fromJS(_data['supplier']) : <any>undefined;
            this.destinationSiteId = _data['destinationSiteId'];
            this.destinationSite = _data['destinationSite'] ? SiteDto.fromJS(_data['destinationSite']) : <any>undefined;
            if (Array.isArray(_data['receptionOrdersIds'])) {
                this.receptionOrdersIds = [] as any;
                for (let item of _data['receptionOrdersIds']) this.receptionOrdersIds!.push(item);
            }
            if (Array.isArray(_data['receptionOrders'])) {
                this.receptionOrders = [] as any;
                for (let item of _data['receptionOrders']) this.receptionOrders!.push(OrderDto.fromJS(item));
            }
            this.purchaseOrderStatus = _data['purchaseOrderStatus'];
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): PurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['documentCode'] = this.documentCode;
        if (Array.isArray(this.goods)) {
            data['goods'] = [];
            for (let item of this.goods) data['goods'].push(item.toJSON());
        }
        data['supplierId'] = this.supplierId;
        data['supplier'] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data['destinationSiteId'] = this.destinationSiteId;
        data['destinationSite'] = this.destinationSite ? this.destinationSite.toJSON() : <any>undefined;
        if (Array.isArray(this.receptionOrdersIds)) {
            data['receptionOrdersIds'] = [];
            for (let item of this.receptionOrdersIds) data['receptionOrdersIds'].push(item);
        }
        if (Array.isArray(this.receptionOrders)) {
            data['receptionOrders'] = [];
            for (let item of this.receptionOrders) data['receptionOrders'].push(item.toJSON());
        }
        data['purchaseOrderStatus'] = this.purchaseOrderStatus;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface IPurchaseOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    documentCode?: string | undefined;
    goods?: GoodsDto[] | undefined;
    supplierId?: number | undefined;
    supplier?: ClientDto;
    destinationSiteId?: number | undefined;
    destinationSite?: SiteDto;
    receptionOrdersIds?: number[] | undefined;
    receptionOrders?: OrderDto[] | undefined;
    purchaseOrderStatus?: SpecializedOrderStatus;
    description?: string | undefined;
    data?: any | undefined;
}

export class ReceiptDto implements IReceiptDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    executionDate?: Date | undefined;
    orderId?: number | undefined;
    order?: OrderDto;
    receiptType?: ReceiptType;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.executionDate = _data['executionDate'] ? new Date(_data['executionDate'].toString()) : <any>undefined;
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? OrderDto.fromJS(_data['order']) : <any>undefined;
            this.receiptType = _data['receiptType'];
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['executionDate'] = this.executionDate ? this.executionDate.toISOString() : <any>undefined;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['receiptType'] = this.receiptType;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface IReceiptDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    executionDate?: Date | undefined;
    orderId?: number | undefined;
    order?: OrderDto;
    receiptType?: ReceiptType;
    description?: string | undefined;
    data?: any | undefined;
}

export enum ReceiptType {
    Transfer = 'Transfer',
    Return = 'Return',
    Delivery = 'Delivery',
    Reception = 'Reception',
}

export class ReturnOrderDataDto implements IReturnOrderDataDto {
    orders?: ReturnOrderDto[] | undefined;
    infoDate?: Date;

    constructor(data?: IReturnOrderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders!.push(ReturnOrderDto.fromJS(item));
            }
            this.infoDate = _data['infoDate'] ? new Date(_data['infoDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReturnOrderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnOrderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['infoDate'] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReturnOrderDataDto {
    orders?: ReturnOrderDto[] | undefined;
    infoDate?: Date;
}

export class ReturnOrderDto implements IReturnOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    originSiteId?: number | undefined;
    originSite?: SiteDto;
    orderGoodsItems?: OrderGoodsItemDto[] | undefined;
    orders?: OrderDto[] | undefined;
    returnOrderStatus?: SpecializedOrderStatus;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IReturnOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.originSiteId = _data['originSiteId'];
            this.originSite = _data['originSite'] ? SiteDto.fromJS(_data['originSite']) : <any>undefined;
            if (Array.isArray(_data['orderGoodsItems'])) {
                this.orderGoodsItems = [] as any;
                for (let item of _data['orderGoodsItems']) this.orderGoodsItems!.push(OrderGoodsItemDto.fromJS(item));
            }
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders!.push(OrderDto.fromJS(item));
            }
            this.returnOrderStatus = _data['returnOrderStatus'];
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): ReturnOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['originSiteId'] = this.originSiteId;
        data['originSite'] = this.originSite ? this.originSite.toJSON() : <any>undefined;
        if (Array.isArray(this.orderGoodsItems)) {
            data['orderGoodsItems'] = [];
            for (let item of this.orderGoodsItems) data['orderGoodsItems'].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['returnOrderStatus'] = this.returnOrderStatus;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface IReturnOrderDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    originSiteId?: number | undefined;
    originSite?: SiteDto;
    orderGoodsItems?: OrderGoodsItemDto[] | undefined;
    orders?: OrderDto[] | undefined;
    returnOrderStatus?: SpecializedOrderStatus;
    description?: string | undefined;
    data?: any | undefined;
}

export class SiteDto implements ISiteDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    name?: string | undefined;
    siteType?: SiteType;
    locationInfo?: any | undefined;
    projectId?: number | undefined;
    project?: ProjectDto;
    goods?: GoodsDto[] | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
    situations?: SituationDto[] | undefined;
    warehouseOwnersAzObjIds?: string[] | undefined;
    data?: any | undefined;

    constructor(data?: ISiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.name = _data['name'];
            this.siteType = _data['siteType'];
            this.locationInfo = _data['locationInfo'];
            this.projectId = _data['projectId'];
            this.project = _data['project'] ? ProjectDto.fromJS(_data['project']) : <any>undefined;
            if (Array.isArray(_data['goods'])) {
                this.goods = [] as any;
                for (let item of _data['goods']) this.goods!.push(GoodsDto.fromJS(item));
            }
            if (Array.isArray(_data['purchaseOrders'])) {
                this.purchaseOrders = [] as any;
                for (let item of _data['purchaseOrders']) this.purchaseOrders!.push(PurchaseOrderDto.fromJS(item));
            }
            if (Array.isArray(_data['situations'])) {
                this.situations = [] as any;
                for (let item of _data['situations']) this.situations!.push(SituationDto.fromJS(item));
            }
            if (Array.isArray(_data['warehouseOwnersAzObjIds'])) {
                this.warehouseOwnersAzObjIds = [] as any;
                for (let item of _data['warehouseOwnersAzObjIds']) this.warehouseOwnersAzObjIds!.push(item);
            }
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): SiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['name'] = this.name;
        data['siteType'] = this.siteType;
        data['locationInfo'] = this.locationInfo;
        data['projectId'] = this.projectId;
        data['project'] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.goods)) {
            data['goods'] = [];
            for (let item of this.goods) data['goods'].push(item.toJSON());
        }
        if (Array.isArray(this.purchaseOrders)) {
            data['purchaseOrders'] = [];
            for (let item of this.purchaseOrders) data['purchaseOrders'].push(item.toJSON());
        }
        if (Array.isArray(this.situations)) {
            data['situations'] = [];
            for (let item of this.situations) data['situations'].push(item.toJSON());
        }
        if (Array.isArray(this.warehouseOwnersAzObjIds)) {
            data['warehouseOwnersAzObjIds'] = [];
            for (let item of this.warehouseOwnersAzObjIds) data['warehouseOwnersAzObjIds'].push(item);
        }
        data['data'] = this.data;
        return data;
    }
}

export interface ISiteDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    name?: string | undefined;
    siteType?: SiteType;
    locationInfo?: any | undefined;
    projectId?: number | undefined;
    project?: ProjectDto;
    goods?: GoodsDto[] | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
    situations?: SituationDto[] | undefined;
    warehouseOwnersAzObjIds?: string[] | undefined;
    data?: any | undefined;
}

export enum SiteType {
    ConstructionSite = 'ConstructionSite',
    Warehouse = 'Warehouse',
    Depot = 'Depot',
}

export class SituationDto implements ISituationDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    title?: string | undefined;
    constructionSiteId?: number;
    constructionSite?: SiteDto;
    goodsExitInfos?: GoodsExitInfoDto[] | undefined;

    constructor(data?: ISituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.title = _data['title'];
            this.constructionSiteId = _data['constructionSiteId'];
            this.constructionSite = _data['constructionSite']
                ? SiteDto.fromJS(_data['constructionSite'])
                : <any>undefined;
            if (Array.isArray(_data['goodsExitInfos'])) {
                this.goodsExitInfos = [] as any;
                for (let item of _data['goodsExitInfos']) this.goodsExitInfos!.push(GoodsExitInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['title'] = this.title;
        data['constructionSiteId'] = this.constructionSiteId;
        data['constructionSite'] = this.constructionSite ? this.constructionSite.toJSON() : <any>undefined;
        if (Array.isArray(this.goodsExitInfos)) {
            data['goodsExitInfos'] = [];
            for (let item of this.goodsExitInfos) data['goodsExitInfos'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISituationDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    title?: string | undefined;
    constructionSiteId?: number;
    constructionSite?: SiteDto;
    goodsExitInfos?: GoodsExitInfoDto[] | undefined;
}

export enum SpecializedOrderStatus {
    Created = 'Created',
    InProgress = 'InProgress',
    Closed = 'Closed',
    Delivered = 'Delivered',
    Cancelled = 'Cancelled',
}

export class WaybillDto implements IWaybillDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    waybillNumber?: string | undefined;
    pickupDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    orderId?: number | undefined;
    order?: OrderDto;
    driverName?: string | undefined;
    driverUniqueNumber?: string | undefined;
    vehicleLicensePlateNum?: string | undefined;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IWaybillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data['created'] ? new Date(_data['created'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.timestamp = _data['timestamp'];
            this.modified = _data['modified'] ? new Date(_data['modified'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.waybillNumber = _data['waybillNumber'];
            this.pickupDate = _data['pickupDate'] ? new Date(_data['pickupDate'].toString()) : <any>undefined;
            this.deliveryDate = _data['deliveryDate'] ? new Date(_data['deliveryDate'].toString()) : <any>undefined;
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? OrderDto.fromJS(_data['order']) : <any>undefined;
            this.driverName = _data['driverName'];
            this.driverUniqueNumber = _data['driverUniqueNumber'];
            this.vehicleLicensePlateNum = _data['vehicleLicensePlateNum'];
            this.description = _data['description'];
            this.data = _data['data'];
        }
    }

    static fromJS(data: any): WaybillDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['created'] = this.created ? this.created.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['timestamp'] = this.timestamp;
        data['modified'] = this.modified ? this.modified.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['waybillNumber'] = this.waybillNumber;
        data['pickupDate'] = this.pickupDate ? this.pickupDate.toISOString() : <any>undefined;
        data['deliveryDate'] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['driverName'] = this.driverName;
        data['driverUniqueNumber'] = this.driverUniqueNumber;
        data['vehicleLicensePlateNum'] = this.vehicleLicensePlateNum;
        data['description'] = this.description;
        data['data'] = this.data;
        return data;
    }
}

export interface IWaybillDto {
    created?: Date | undefined;
    createdBy?: string | undefined;
    timestamp?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    tenantId?: string | undefined;
    id?: number;
    waybillNumber?: string | undefined;
    pickupDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    orderId?: number | undefined;
    order?: OrderDto;
    driverName?: string | undefined;
    driverUniqueNumber?: string | undefined;
    vehicleLicensePlateNum?: string | undefined;
    description?: string | undefined;
    data?: any | undefined;
}

export class WaybillFullInfoDto implements IWaybillFullInfoDto {
    waybill?: WaybillDto;
    order?: OrderDto;
    goods?: GoodsDto[] | undefined;
    originSite?: SiteDto;
    destinationSite?: SiteDto;

    constructor(data?: IWaybillFullInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waybill = _data['waybill'] ? WaybillDto.fromJS(_data['waybill']) : <any>undefined;
            this.order = _data['order'] ? OrderDto.fromJS(_data['order']) : <any>undefined;
            if (Array.isArray(_data['goods'])) {
                this.goods = [] as any;
                for (let item of _data['goods']) this.goods!.push(GoodsDto.fromJS(item));
            }
            this.originSite = _data['originSite'] ? SiteDto.fromJS(_data['originSite']) : <any>undefined;
            this.destinationSite = _data['destinationSite'] ? SiteDto.fromJS(_data['destinationSite']) : <any>undefined;
        }
    }

    static fromJS(data: any): WaybillFullInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillFullInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['waybill'] = this.waybill ? this.waybill.toJSON() : <any>undefined;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.goods)) {
            data['goods'] = [];
            for (let item of this.goods) data['goods'].push(item.toJSON());
        }
        data['originSite'] = this.originSite ? this.originSite.toJSON() : <any>undefined;
        data['destinationSite'] = this.destinationSite ? this.destinationSite.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWaybillFullInfoDto {
    waybill?: WaybillDto;
    order?: OrderDto;
    goods?: GoodsDto[] | undefined;
    originSite?: SiteDto;
    destinationSite?: SiteDto;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any,
): any {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}
